import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Avatar, Card, Divider, Popover } from "antd";
import { USABLE_ICONS } from "variables/constants";
import { Briefcase } from "lucide-react";
import { getEmployeeAwardList } from "../../../../../redux/employeeaward/employeeAwardState";
import dayjs from "dayjs";

const AwardeeDetails = ({ item }) => {
  const colorClass = item?.award_color_class?.toLowerCase();

  // Use item.award_icon like AvatarGrid
  const IconComponent =
    item?.award_icon && USABLE_ICONS[item.award_icon]
      ? USABLE_ICONS[item.award_icon]
      : null;

  const name = item?.employee_name || "-";
  const role = item?.employee_position || "-";
  const category = item?.award_title || "-";
  const achievement = item?.ema_feedback || "-";
  const country = "🇵🇭 Philippines";
  const awardMonth = item?.ema_issued_at
    ? dayjs(item.ema_issued_at).format("MMMM YYYY")
    : "-";

  const initials =
    item?.employee_name
      ?.split(" ")
      .map((n) => n[0])
      .join("") || "-";

  return (
    <Card className={`flex rounded-xl card-theme ${colorClass} w-full hover:shadow-md transition-all`}>
      <div className="flex items-start justify-between">
        <div className="relative inline-block">
          <Avatar
            size={64}
            className={`!rounded-full border-4 border-white shadow-md icon-style ${colorClass} flex items-center justify-center`}
          >
            {initials}
          </Avatar>

          <Popover
            content={category}
            trigger="hover"
            placement="top"
            overlayClassName="reward-popover"
          >
            <div
              className={`absolute -right-1 -bottom-1 w-8 h-8 !rounded-full icon-style ${colorClass} shadow-lg border-2 border-white flex items-center justify-center cursor-pointer hover:scale-110 transition-transform`}
            >
              {IconComponent &&
                React.createElement(IconComponent, { className: "w-4 h-4 text-white" })}
            </div>
          </Popover>
        </div>

        <span className={`status-indicator ${colorClass} text-xs`}>
          {category}
        </span>
      </div>

      <div className="flex flex-col mt-3 space-y-3">
        <div>
          <h4 className="flex gap-2 font-semibold text-base title-text">
            {name}
          </h4>
          <p className="text-xs mb-2 muted-text">{role}</p>
          <p className="text-xs muted-text">{country}</p>
          <p className="text-xs muted-text">{awardMonth}</p>
        </div>

        <span className="inline-flex gap-1 items-center text-[10px] muted-text px-2 py-1 rounded-md bg-slate-200 dark:bg-slate-700 w-fit">
          <Briefcase className="w-3 h-3" />
          TechCorp Solutions
        </span>
      </div>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

      <p className="muted-text text-xs">
        {achievement}
      </p>
    </Card>
  );
};

const AwardeeCard = ({ recordList, pagination, doSearch }) => {
  useEffect(() => {
    doSearch({ paginate: pagination?.per_page });
  }, [doSearch, pagination?.per_page]);

  const filteredList = recordList?.filter(item => item?.ema_status_id === 1);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {filteredList?.map(item => (
        <AwardeeDetails key={item.id} item={item} />
      ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeAward.employeeAwardList?.items,
  pagination: state.employeeAward.employeeAwardList?.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeAwardList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardeeCard);